import { Phone, Mail, MapPin, Sun } from "lucide-react";
import { COMPANY } from "@/data/site";

const quick = [
  { id: "about", label: "About" },
  { id: "why", label: "Why Us" },
  { id: "products", label: "Products" },
  { id: "leadership", label: "Leadership" },
  { id: "enquiry", label: "Get a Quote" },
];

const go = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="relative border-t border-white/5 bg-[#050B14]"
    >
      <div className="container-x py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="inline-flex h-12 w-12 rounded-full bg-white items-center justify-center overflow-hidden shadow-[0_0_24px_rgba(255,200,87,0.35)]">
                <img
                  src={COMPANY.logo}
                  alt="Jashvi Energy Solutions"
                  className="h-11 w-11 object-contain"
                />
              </span>
              <span className="font-serif text-2xl text-white leading-tight">
                Jashvi Energy
                <span className="block text-[11px] uppercase tracking-[0.3em] text-[#FFC857] font-sans font-light">
                  Solutions
                </span>
              </span>
            </div>
            <p className="mt-5 text-[#A0ABC0] font-light text-sm md:text-base max-w-md leading-relaxed">
              Premium rooftop solar installations — Tier 1 components, in-house
              engineering, decade-long care. Serving {COMPANY.serviceArea}.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#FFC857]">
              <Sun className="h-4 w-4" /> {COMPANY.serviceArea}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.3em] text-[#FFC857] mb-5">
              Navigate
            </div>
            <ul className="space-y-3">
              {quick.map((q) => (
                <li key={q.id}>
                  <button
                    data-testid={`footer-link-${q.id}`}
                    onClick={() => go(q.id)}
                    className="text-sm text-[#A0ABC0] hover:text-[#FFC857] transition-colors"
                  >
                    {q.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.3em] text-[#FFC857] mb-5">
              Contact
            </div>
            <ul className="space-y-4 text-sm">
              {COMPANY.phones.map((p) => (
                <li key={p} className="flex items-center gap-3 text-[#A0ABC0]">
                  <Phone className="h-4 w-4 text-[#FFC857]" />
                  <a
                    data-testid={`footer-phone-${p}`}
                    href={`tel:${p}`}
                    className="hover:text-white transition-colors font-light"
                  >
                    +91 {p.slice(0, 5)} {p.slice(5)}
                  </a>
                </li>
              ))}
              <li className="flex items-center gap-3 text-[#A0ABC0]">
                <Mail className="h-4 w-4 text-[#FFC857]" />
                <a
                  data-testid="footer-email"
                  href={`mailto:${COMPANY.email}`}
                  className="hover:text-white transition-colors font-light"
                >
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-[#A0ABC0]">
                <MapPin className="h-4 w-4 text-[#FFC857] mt-0.5 shrink-0" />
                <span className="font-light leading-relaxed">
                  {COMPANY.address}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-[#A0ABC0]/70 font-light">
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <p className="text-xs text-[#A0ABC0]/70 font-light">
            Proprietor — Shalini Ashwath · Bengaluru, Karnataka
          </p>
        </div>
      </div>
    </footer>
  );
}
